export const DEFAULT_LANGUAGE = 'en';
export const ALLOWED_LANGUAGES =
  typeof AVAILABLE_LANGUAGES === 'undefined'
    ? [DEFAULT_LANGUAGE]
    : AVAILABLE_LANGUAGES;
